import React__default from 'react';
import PropTypes from 'prop-types';

function Divider(props) {
  var className = props.className;
  var space = props.space;
  var allowedSpaces = ['normal', 'large', 'none'];
  space = allowedSpaces.some(function (validMargin) {
    return validMargin === space;
  }) ? " bf-divider-space-".concat(space) : '';
  var dividerClassName = "bf-divider ".concat(space, " ").concat(className);
  return /*#__PURE__*/React__default.createElement("hr", {
    className: dividerClassName
  });
}
Divider.defaultProps = {
  space: 'normal',
  className: ''
};
Divider.propTypes = {
  /**
  Top and bootom margins
   */
  space: PropTypes.string,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default Divider;
//# sourceMappingURL=Divider.js.map
